/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    var icon = button.find("i");
    if (data.success) {
        changeIcon(icon);
        status = "alert-success";
    } else {
        status = "alert-danger";
    }

    if ($(".add-to-wishlist-messages").length === 0) {
        if ($(window).width() > 992) { // NOSONAR
            $("body").append("<div class=\"add-to-wishlist-messages \"></div>");
        } else {
            $("body").append("<div class=\"add-to-wishlist-messages \"></div>");
        }
    }

    let wishlistTag = $(".js-link-wishlist");
    let isObfuscated = wishlistTag.data("obfuscated");
    let linkWishlist = isObfuscated ? wishlistTag.data("url") : wishlistTag.attr("href");
    let linkWishlistTitle = wishlistTag.attr("title");
    let isError = status === "alert-danger";

    if (isObfuscated) {
        linkWishlist = atob(linkWishlist);
    }

    if (data.action === "Wishlist-AddProduct" && !isError) {
        $(".add-to-wishlist-messages").append("<div class=\"add-to-wishlist-alert text-center " + status + "\">" + data.msg + "<a href=\"" + linkWishlist + "\" title=\"" + linkWishlistTitle + "\">" + data.link + "</a></div>");
    } else {
        $(".add-to-wishlist-messages").append("<div class=\"add-to-wishlist-alert text-center " + status + "\">" + data.msg + "</div>");
    }

    setTimeout(function () {
        $(".add-to-wishlist-messages").remove();
        button.removeAttr("disabled");
    }, 5000);
}

/**
 * appends params to a url
 * @param {Object} icon - Icon that was clicked to add a product to the wishlist
 */
function changeIcon(icon) {
    icon.toggleClass("cwf-star").toggleClass("cwf-star-empty");
}

module.exports = {
    addToWishlist: function () {
        var $wishlistBtn = $(".product-detail__top--visuals--wishlist");

        $wishlistBtn.each((index) => {
            let $wishlist = $($wishlistBtn[index]);

            $wishlist.find(".add-to-wish-list").on("click", function (e) {
                e.preventDefault();

                let url = null;

                if ($wishlist.hasClass("not-wishlisted")) {
                    url = $(this).data("add-url");
                } else {
                    url = $(this).data("remove-url");
                }

                var button = $(this);
                var pid = $(this).closest(".product-detail").find(".product-id").html();
                var optionId = $(this).closest(".product-detail").find(".product-option").attr("data-option-id");
                var optionVal = $(this).closest(".product-detail").find(".options-select option:selected").attr("data-value-id");
                optionId = optionId || null;
                optionVal = optionVal || null;
                if (!url || !pid) {
                    return;
                }

                if ($wishlist.hasClass("not-wishlisted")) {
                    $wishlist.removeClass("not-wishlisted").addClass("wishlisted");
                    $.spinner().start();
                    $(this).attr("disabled", true);
                    $.ajax({
                        url: url,
                        type: "post",
                        dataType: "json",
                        data: {
                            pid: pid,
                            optionId: optionId,
                            optionVal: optionVal
                        },
                        success: function (data) {
                            displayMessage(data, button);
                        },
                        error: function (err) {
                            displayMessage(err, button);
                        }
                    });
                } else {
                    $wishlist.removeClass("wishlisted").addClass("not-wishlisted");
                    $.spinner().start();
                    $(this).attr("disabled", true);
                    $.ajax({
                        url: url,
                        type: "get",
                        dataType: "json",
                        data: {
                            pid: pid
                        },
                        success: function (data) {
                            displayMessage(data, button);
                        },
                        error: function (err) {
                            displayMessage(err, button);
                        }
                    });
                }
            });
        });
    },
    /**
    * Fetches and displays the wishlist status for a product on PDP
    * @function
    * @name showWishlistStatus
    * @returns {void}
    */
    showWishlistStatus: function () {
        var $wishlistBtn = $(".product-detail__top--wishlist");
        var url = $wishlistBtn.data("fetch-wishlist-url");
        var pid = $(".product-detail").find(".product-id").html();
        $(window).on("load", function () {
            $.ajax({
                url: url,
                type: "get",
                dataType: "json",
                data: {
                    pid: pid
                },
                success: function (data) {
                    if (data && data.list && data.list.items && data.list.items.length) {
                        var foundInList = data.list.items.filter(function (item) { return item.pid === pid;});
                        if (foundInList.length > 0) {
                            changeIcon($wishlistBtn.find("i"));
                            $wishlistBtn.closest(".product-detail__top--visuals--wishlist").toggleClass("not-wishlisted wishlisted");
                        }
                    }
                },
                error: function (err) {
                    displayMessage(err, $wishlistBtn);
                }
            });
        });
    }
};
